<!-- 循环模板设置 -->
<template>
    <div class="LoopSchedulerTemplate">
       <el-dialog
        :title="$t('lang.DefaultTemplateSchedule')"
        :visible.sync="LoopTemplate.switch"
        width="600px"
        :close-on-click-modal="false"
      >
        <div class="DefaultTemplate">
          <div class="RecurringSetting">{{$t('lang.RecurringScheduleSetting')}}</div>
          <div class="formTitle">{{ $t('lang.RecurringSchedule') }}</div>
          <div class="formInput" id="formInput" >
            <el-select
              v-model="TemplateId"
              @change="TemplateChange"
              :popper-append-to-body="false"
              v-scroll="bindScroll"
              filterable
              :filter-method="searchFile"
              @focus="FirstGetData"
              :loading="FirstLoading"
              :placeholder="$t('lang.ChooseTemplate')">
              <el-option
                v-for="item in TemplateList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="formTitle">{{ $t('lang.LoopStartEndDate') }}</div>
          <div class="formInput SelectTimeWrap">
            <div class="LoopSelectTime">
              <el-date-picker
                popper-class="pick_date_timebk"
                v-model="LoopMessage.recurStartTime"
                type="date"
                value-format="timestamp"
                :format="PickerFormat.Date"
                :placeholder="$t('lang.date')"
              >
              </el-date-picker>
               <i class="el-icon-date"></i>
            </div>
            <div class="LoopSelectTime">
              <el-select
                v-model="LoopEndTime"
                @change="TimeTypeChange"
                :placeholder="$t('lang.select')">
                  <el-option
                    v-for="(item, index) in EndTimeType"
                    :key="index"
                    :label="$t(`lang.${item}`)"
                    :value="index"
                  >
                  </el-option>
                </el-select>
                 <i class="el-icon-date"></i>
            </div>
          </div>
        </div>
        <div class="CustomTime" v-show="TimeSelectSwitch">
            <div class="CustomTimeHead">
              <div class="name">
                {{$t('lang.Custom')}}
              </div>
              <div @click="TimeSelectCancel">
                <i class="iconfont icon-a-closethick"></i>
              </div>
            </div>
            <div class="CustomTimeContent">
              <div class="title">{{$t('lang.Until')}}</div>
              <el-date-picker
                popper-class="pick_date_timebk"
                v-model="LoopMessage.recurEndTime"
                type="date"
                value-format="timestamp"
                :format="PickerFormat.SelectADate"
                :placeholder="$t('lang.date')"
              >
              </el-date-picker>
              <i class="el-icon-date"></i>
            </div>
            <div class="BottomBtn">
              <el-button
                size="small"
                class="cancelButton"
                @click="TimeSelectCancel">{{ $t("lang.cancel") }}</el-button>
              <el-button
                size="small"
                type="primary"
                class="saveButton"
                @click="TimeSelectSave">{{ $t("lang.ConfirmBtn") }}</el-button>
            </div>
        </div>
        <div class="BottomBtn">
          <el-button
            size="small"
            class="cancelButton"
            @click="cancel"
            >{{ $t("lang.cancel") }}</el-button
          >
          <el-button
            size="small"
            :class="[LoopTemplate.id ?'cancelButton':'noDisable' ]"
            @click="DisableLoop"
            >{{ $t("lang.Disable") }}</el-button
          >
          <el-button
            size="small"
            type="primary"
            class="saveButton"
            @click="save"
            >{{ $t("lang.ConfirmBtn") }}</el-button
          >
        </div>
      </el-dialog>
    </div>
</template>

<script>
import toTips from '@/assets/js/toTipsObj'
import Outil from '@/assets/js/utils.js'
export default {
  props: {
    // 循环模板信息及开关
    LoopTemplate: {
      type: Object,
      default: () => ({
        switch: true
      })
    }
  },
  data () {
    return {
      // 模板列表
      TemplateList: [],
      // STemplate绑定滚动事件
      bindScroll: {
        onScroll: this.GetTemplateList,
        directive: '.el-select-dropdown__wrap',
        distance: 50
      },
      STemplateParam: {
        pageNum: 0,
        pageSize: 10,
        totalNum: 1,
        condition: ''
      },
      // 时间选择开关
      TimeSelectSwitch: false,
      // 时间格式
      PickerFormat: {
        DateTime: 'yyyy-MM-dd h:mm:ss A',
        Date: 'yyyy-MM-dd'
      },
      // 循环信息
      LoopMessage: {
        id: '444444',
        scheduleType: '1',
        recurStartTime: null,
        recurEndTime: null,
        TimeType: 0
      },
      // 选择的模板
      TemplateId: '',
      // 结束时间类型
      EndTimeType: ['Indefinite', 'Custom'],
      // 选择结束时间
      LoopEndTime: 0,
      // 加载
      FirstLoading: false
    }
  },
  watch: {
    LoopTemplate () {
      this.getLoopMessage()
    }
  },
  created () {
    // 获取时间格式
    this.PickerFormat = Outil.getDateTimePickerFormat()
    this.getLoopMessage()
  },
  mounted () {

  },
  methods: {
    // 获取循环信息
    getLoopMessage () {
      if (this.LoopTemplate.id) {
        this.LoopMessage = JSON.parse(JSON.stringify(this.LoopTemplate))
        this.TemplateId = this.LoopTemplate.id
        if (this.LoopTemplate.name) {
          this.TemplateId = this.LoopTemplate.name
        }
        if (this.LoopTemplate.recurEndTime != null && this.LoopTemplate.recurEndTime) {
          this.LoopMessage.TimeType = 1
          this.EndTimeGive()
        } else {
          this.LoopMessage.TimeType = 0
        }
      }
    },
    // 模板变化
    TemplateChange (key) {
      const Template = this.TemplateList.filter((item) => item.id == key)
      if (Template[0]) {
        this.LoopMessage.id = Template[0].id
        this.LoopMessage.name = Template[0].name
        this.LoopMessage.scheduleType = Template[0].scheduleType
      }
    },
    // 第一次获取数据
    FirstGetData () {
      if (this.TemplateList.length === 0) {
        this.FirstLoading = true
        this.GetTemplateList()
      }
    },
    // 搜索文件列表
    searchFile (value) {
      this.STemplateParam.pageNum = 0
      this.STemplateParam.condition = value
      this.GetTemplateList()
    },
    // 获取模板列表
    GetTemplateList () {
      if (this.STemplateParam.pageNum >= this.STemplateParam.totalNum) return
      this.STemplateParam.pageNum++
      this.axios
        .post(
          '/gatewayPlayoutUrl/tvu-playout/template/listTemplate',
          this.STemplateParam
        )
        .then((res) => {
          this.FirstLoading = false
          if (res.data.errorCode == '0x0') {
            if (this.STemplateParam.pageNum > 1) {
              this.TemplateList.push(...res.data.result.list)
            } else {
              //   拿第一页时存总页数
              this.STemplateParam.totalNum = res.data.result.pages ? res.data.result.pages : 1
              this.TemplateList = res.data.result.list
            }
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {})
    },
    // e类型选择变化
    TimeTypeChange (key) {
      this.LoopMessage.TimeType = key
      if (key == 1) {
        this.TimeSelectSwitch = key
      } else {
        this.LoopMessage.recurEndTime = null
      }
    },
    // 类型赋值
    EndTimeGive () {
      this.LoopEndTime = this.LoopMessage.TimeType
      if (this.LoopEndTime == 1 && this.LoopMessage.recurEndTime) {
        const Time = Outil.changeNewDate(this.LoopMessage.recurEndTime)
        this.LoopEndTime = `Until ${Time}`
      }
    },
    // 时间选择取消
    TimeSelectCancel () {
      if (this.LoopMessage.recurEndTime) {
        this.TimeSelectSwitch = false
        this.EndTimeGive()
      } else {
        this.TimeSelectSwitch = false
        this.LoopEndTime = 0
        this.LoopMessage.TimeType = 0
        this.LoopMessage.recurEndTime = null
      }
    },
    // 时间选择保存
    TimeSelectSave () {
      if (this.LoopMessage.recurEndTime) {
        this.TimeSelectSwitch = false
        this.EndTimeGive()
      } else {
        this.$message.warning(this.$t('lang.CustomTimeSelect'))
      }
    },
    cancel () {
      this.LoopTemplate.switch = false
    },
    DisableLoop () {
      const programId = this.$BehaviorSyns.getProgramId()
      this.axios
        .post('/gatewayPlayoutUrl/tvu-playout/template/cancelRecurTemplate',
          { programId }
        )
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.LoopTemplate.switch = false
            this.$emit('LoopTemplateUpdate')
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {})
    },
    save () {
      const programId = this.$BehaviorSyns.getProgramId()
      this.axios
        .post(
          '/gatewayPlayoutUrl/tvu-playout/template/saveRecurTemplate',
          {
            ...this.LoopMessage,
            programId,
            recurProgramId: programId
          }
        )
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.LoopTemplate.switch = false
            this.$emit('LoopTemplateUpdate')
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {})
    }
  }
}
</script>

<style scoped lang="less">
.LoopSchedulerTemplate {
  ::v-deep .el-dialog__body{
    padding-top: 18px;
  }
  .DefaultTemplate{
    text-align: left;
    .RecurringSetting {
      font-size: 14px;
      line-height: 16px;
      color: #DBDBDB;
    }
    .formTitle {
      font-size: 14px;
      color: #DBDBDB;
      line-height: 17px;
      margin-bottom: 5px;
      margin-top: 5px;
      span {
        color: #E56464;
      }
    }
    ::v-deep .formInput {
      margin-bottom: 10px;
      .el-input__inner {
        height: 32px;
        background: #444444;
        border-radius: 4px;
        border: 1px solid #353535;
        color: #DBDBDB;
        padding-left: 10px;
      }
      input::-webkit-input-placeholder {
        color: #666666;
      }
      .LoopSelectTime {
        position: relative;
        .el-input__inner{
          width: 250px;
        }
        .el-date-editor{
          width: 250px;
          .el-input__inner{
            border: none;
            width: 250px;
            height: 32px;
            background: #444444;
            padding-left: 10px;
          }
          .el-input__prefix{
            display: none;
          }
          .el-input__suffix{
            right: 23px;
          }
        }
        .el-select {
          .el-input__suffix-inner{
            display: none;
          }
        }
        .el-icon-date{
          position: absolute;
          right: 8px;
          top: 9px;
        }
      }
    }
    .SelectTimeWrap{
      display: flex;
      justify-content: space-between;
    }
    #formInput {
      ::v-deep .el-select {
        width: 100%;
        padding-left: 0px;
        .el-select-dropdown__wrap::-webkit-scrollbar-thumb {
          display: none;
        }
      }
    }
  }
  .CustomTime{
    position: absolute;
    top: 0;
    left: 103%;
    background: #252525;
    width: 288px;
    padding: 0 24px 24px;
    text-align: left;
    border-radius: 6px;
    .CustomTimeHead{
      height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 2px solid #444444;
    }
    .CustomTimeContent{
      position: relative;
      .title{
        margin: 16px 0 12px;
        font-size: 14px;
        line-height: 16px;
        color: #DBDBDB;
      }
      ::v-deep .el-date-editor{
        .el-input__inner{
          border: none;
          width: 240px;
          height: 32px;
          background: #444444;
          padding-left: 10px;
        }
        .el-input__prefix{
          display: none;
        }
      }
      .el-icon-date{
        position: absolute;
        right: 8px;
        top: 37px;
      }
    }
  }
  ::v-deep .BottomBtn{
    text-align: right;
    padding-top: 24px;
    .el-button{
      height: 32px;
      border-radius: 4px;
      font-size: 14px;
      color: #DBDBDB;
      padding: 0;
      text-align: center;
      line-height: 32px;
      margin-left: 16px;
    }
    .cancelButton{
      width: 80px;
      background: #666666;
    }
    .noDisable{
      width: 80px;
      background: #444444;
      color: #252525;
      cursor: not-allowed;
    }
    .ClearFields{
      width: 110px;
      background: #666666;
    }
    .saveButton{
      width: 80px;
      background: #33AB4F;
    }
  }
}

</style>
